import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Dropdown, Input, Menu} from 'antd';
import {StyledUserSelectDropdown} from './StyledUserSelectDropdown';
import UserDetails from '../UserDetails';

const UserSelectDropdown = ({
  dispatch,
  employees = [],
  children,
  listPropName = 'employee_id',
  onSelect,
  selectedValue,
  hideSelected = false,
  ...rest
}) => {
  const [t] = useTranslation('main');
  const [search, setSearch] = React.useState('');

  const filteredEmployees = employees
    .filter(emp => emp.full_name.toLowerCase().includes(search.toLowerCase()))
    .filter(emp => !hideSelected || emp[listPropName] !== selectedValue);

  return (
    <Dropdown
      trigger={['click']}
      popupRender={() => (
        <StyledUserSelectDropdown>
          <Input
            onChange={e => setSearch(e.target.value)}
            placeholder={t('search')}
            value={search}
          />
          <Menu onClick={({ domEvent, key }) => onSelect?.(domEvent, key)}>
            {filteredEmployees.map((emp) => (
              <Menu.Item key={emp[listPropName]}>
                <UserDetails user={emp} email={false} avatarProps={{ size: 24 }} />
              </Menu.Item>
            ))}
          </Menu>
        </StyledUserSelectDropdown>
      )}
      {...rest}
    >
      {children}
    </Dropdown>
  );
}

UserSelectDropdown.propTypes = {
  listPropName: PropTypes.string,
  onSelect: PropTypes.func,
  selectedValue: PropTypes.any,
  hideSelected: PropTypes.bool,
}

const mapStateToProps = state => ({
  employees: state.company.employees
});

export default connect(mapStateToProps, null)(UserSelectDropdown);
